<template>
  <b-modal 
    centered
    ref="modal"
    v-if="item"
  >
    <template #modal-title>
      <i class='bx bx-package'></i>
      {{item.barcode}}
      <status v-bind="{item}" />
    </template>

    <dl style="overflow-wrap: anywhere">
      <div class="row row-cols-1 row-cols-sm-2">
        <div class="col">
            <value label="shipments.consignee" icon="bx-purchase-tag" :value="item.$shipment.name" />
        </div>
        <div class="col">
            <value label="common.phone" icon="bx-phone" :value="item.$shipment.phone" />
        </div>
        <div class="col">
            <value label="common.email" icon="bx-envelope" :value="item.$shipment.email" />
        </div>
        <div class="col">
            <value label="merchants.label" icon="bx-cart" :value="item.$shipment.merchant_name" />
        </div>
        <div class="col">
            <value label="driver.packages-in-shipment" icon="bx-package" :value="$tc(`packages.pluralize`,item.$shipment.package_count) | ucfirst" />
        </div>
        <div class="col">
            <value label="driver.destination" icon="bx-map" :value="item.dropoff_location_name" />
        </div>
        <div class="col" v-if="item.is_consolidation">
          <value label="packages.consolidations" icon="bx-unite">
            <a 
              v-for="(consolidation) in item.$consolidations"
              :key="consolidation.id"
              @click="close({barcode: consolidation.barcode})"
              class="d-block linkish text-info"
            >
              {{consolidation.barcode}}
            </a>
          </value>
        </div>
        <div class="col" v-else-if="item.is_consolidated">
          <value label="packages.consolidated" icon="bx-unite">
            <a 
              @click="close({barcode: item.$meta.consolidated_to.barcode})"
              class="d-block linkish text-info"
            >
              {{item.$meta.consolidated_to.barcode}}
            </a>
          </value>
        </div>
      </div>
    </dl>

    <template #modal-footer style="justify-content: space-between">
      <b-button @click="close(null)">{{$t('common.close')}}</b-button>
      <async-button v-if="item.$meta.actions.reroute" variant="info" :handler="reroute">
        {{$t(`driver.actions.reroute`)}}
      </async-button>
      <async-button v-if="item.$meta.actions.pickup" variant="primary" :handler="pickup">
        {{$t(`driver.actions.pickup`)}}
      </async-button>
      <async-button v-if="item.$meta.actions.consolidate" variant="primary" :handler="consolidate">
        {{$t(`driver.actions.consolidate`)}}
      </async-button>
      <async-button v-else-if="item.$meta.actions.deconsolidate" variant="danger" :handler="deconsolidate">
        {{$t(`packages.actions.deconsolidate`)}}
      </async-button>
    </template>
  </b-modal>
</template>

<script>
import Modal from "@/components/Modal"
import Value from "@/components/Value"
import RerouteModal from "@/components/Modals/Reroute"
import ConsolidateModal from "@/components/Modals/Consolidate"
import Package from '@/resources/Package'
import Status from '@/components/Status'
import { vibrate } from '@/utils'
import AsyncButton from "@/components/AsyncButton.vue"

export default {
  name: 'DriverModal',
  extends: Modal,
  components: {Value, Status, AsyncButton},
  props: {
    item: {
      type: Package,
      required: true,
    },
  },
  computed: {
    actions() {
      const actions = []
      if(this.item.$meta.actions.reroute) {
        actions.push('reroute')
      }
      if(this.item.$meta.actions.pickup) {
        actions.push('pickup')
      }
      return actions
    },
    barcode() {
      return `${process.env.VUE_APP_API_HOST}barcode/${this.item.barcode}`
    }
  },
  methods: {
    async reroute() {
      await this.$modal(RerouteModal,{item: this.item})
      this.close(null)
    },
    async pickup() {
      const confirm = await this.$bvModal.msgBoxConfirm(this.$t('driver.actions.pickup-confirm'),{
        cancelTitle: this.$t('common.cancel'),
        okTitle: this.$t('driver.actions.pickup'),
      })

      if(confirm) {
        await this.item.$pickup()
        this.item.$meta.consolidatable && vibrate('consolidatable')
        this.close(null)
      }
    },
    async consolidate() {
      await this.$modal(ConsolidateModal,{item: this.item})
      this.close(null)
    },
    async deconsolidate() {
      const confirm = await this.$bvModal.msgBoxConfirm(this.$t('packages.actions.deconsolidate-confirm-text'),{
        cancelTitle: this.$t('common.cancel'),
        okTitle: this.$t('packages.actions.deconsolidate'),
        okVariant: 'danger',
      })

      if(confirm) {
        await this.item.$deconsolidate()
        this.close(null)
      }
    }
  }
}
</script>